<template>
  <!-- 添加线索 -->
  <div class="add-clue" v-loading="loading">
    <!-- 基础信息表单 -->
    <el-form
      ref="baseForm"
      :model="formData"
      label-width="90px"
      class="base-form"
    >
      <!-- 医生姓名 -->
      <custom-form-item
        type="input"
        prop="doctor_name_formCode_FR001"
        v-model="formData.doctor_name_formCode_FR001"
        :fieldInfo="showFormFieldKeyInfo.doctor_name_formCode_FR001 || {}"
      />
      <!-- 性别 -->
      <custom-form-item
        type="select"
        prop="sex_formCode_FR001"
        v-model="formData.sex_formCode_FR001"
        :options="originOptionsInfo.sex_formCode_FR001 || []"
        :fieldInfo="showFormFieldKeyInfo.sex_formCode_FR001 || {}"
      />
      <el-form-item
        label="新增线索给"
        prop="assignTo"
        :rules="[
          { required: true, message: '请选择新增线索给', trigger: 'change' }
        ]"
      >
        <el-select v-model="formData.assignTo" placeholder="请选择" size="small" class="form-select">
          <el-option label="跟进人" value="follower"></el-option>
          <el-option label="公海-推进池" value="public"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="formData.assignTo === 'follower'"
        label="选择跟进人"
        prop="follower"
        :rules="[
          { required: true, message: '请选择跟进人', trigger: 'change' }
        ]"
      >
        <el-select
          v-model="formData.follower"
          placeholder="请选择"
          filterable
          size="small"
          class="form-select"
        >
          <el-option label="杨一一" value="yangyiyi"></el-option>
          <el-option label="杨姗姗" value="yangshanshan"></el-option>
          <el-option label="李某某" value="limoumou"></el-option>
          <el-option label="王某某" value="wangmoumou"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!-- 标签页切换按钮 -->
    <div v-if="!isExpanded" class="tab-toggle">
      <span class="toggle-btn" @click="isExpanded = !isExpanded">
        <span>填写更多线索信息</span>
        <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </span>
    </div>

    <!-- 展开的标签页内容 -->
    <div v-if="isExpanded" class="expand-content">
      <!-- 粘性标签页 -->
      <el-tabs v-model="activeTab" class="clue-tabs">
        <el-tab-pane label="基本信息" name="basic"></el-tab-pane>
        <el-tab-pane label="坐诊信息" name="clinic"></el-tab-pane>
        <el-tab-pane label="辅助信息" name="assistant"></el-tab-pane>
        <el-tab-pane label="医生期望" name="doctorWish"></el-tab-pane>
      </el-tabs>

      <!-- 标签页内容区域 -->
      <div class="tab-content-area">
        <!-- 基本信息 -->
        <div v-show="activeTab === 'basic'" class="tab-section">
          <el-form
            ref="baseInfoForm"
            :model="formData"
            label-width="90px"
          >
            <div class="form-grid">
              <el-form-item label="出生日期">
                <el-date-picker
                  style="width: 100%;"
                  v-model="formData.birth_formCode_FR100"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  size="small"
                  class="form-input"
                />
              </el-form-item>
              <!-- 年龄 -->
              <custom-form-item
                type="input"
                prop="age_formCode_FR100"
                v-model="formData.age_formCode_FR100"
                :fieldInfo="showFormFieldKeyInfo.age_formCode_FR100 || {}"
              />
              <custom-form-item
                type="input"
                prop="phone_formCode_FR100"
                v-model="formData.phone_formCode_FR100"
                :fieldInfo="showFormFieldKeyInfo.phone_formCode_FR100 || {}"
              />
              <!-- 籍贯 -->
              <custom-form-item
                type="cascader"
                prop="placeOfOrigin"
                :cascaderProps="{
                  value: 'code',
                  label: 'name',
                  children: 'list'
                }"
                v-model="formData.province_native_place_formCode_FR100"
                label="籍贯"
                :cascaderOptions="areaList || []"
                :fieldInfo="showFormFieldKeyInfo.province_native_place_formCode_FR100 || {}"
              />
              <!-- 职称 -->
              <custom-form-item
                type="select"
                prop="aa_formCode_FR100"
                v-model="formData.aa_formCode_FR100"
                :options="originOptionsInfo.aa_formCode_FR100 || []"
                :fieldInfo="showFormFieldKeyInfo.aa_formCode_FR100 || {}"
              />
              <!-- 荣誉称号 -->
              <custom-form-item
                type="multiple-select"
                prop="ab_formCode_FR100"
                v-model="formData.ab_formCode_FR100"
                filterable
                :options="originOptionsInfo.ab_formCode_FR100 || []"
                :fieldInfo="showFormFieldKeyInfo.ab_formCode_FR100 || {}"
              />
            </div>
          </el-form>
        </div>

        <!-- 坐诊信息 -->
        <div v-show="activeTab === 'clinic'" class="tab-section">
          <div class="form-grid">
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">坐诊医院</span>
              <el-input v-model="clinicInfo.hospital" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">科室</span>
              <el-input v-model="clinicInfo.department" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">诊室</span>
              <el-input v-model="clinicInfo.room" placeholder="请填写" size="small" class="form-input" />
            </div>
            <div class="form-row">
              <span class="form-label">出诊时间</span>
              <el-input v-model="clinicInfo.time" placeholder="请填写" size="small" class="form-input" />
            </div>
          </div>
        </div>

        <!-- 辅助信息 -->
        <div v-show="activeTab === 'assistant'" class="tab-section">
          <el-form
            ref="assistantInfoForm"
            :model="formData"
            label-width="90px"
          >
            <div class="form-grid">
              <!-- 婚姻状况 -->
              <custom-form-item
                type="select"
                prop="is_marry_formCode_FR101"
                v-model="formData.is_marry_formCode_FR101"
                :options="originOptionsInfo.is_marry_formCode_FR101 || []"
                :fieldInfo="showFormFieldKeyInfo.is_marry_formCode_FR101 || {}"
              />
              <!-- 子女情况 -->
              <custom-form-item
                type="textarea"
                prop="children_formCode_FR101"
                v-model="formData.children_formCode_FR101"
                :fieldInfo="showFormFieldKeyInfo.children_formCode_FR101 || {}"
              />
              <!-- 家庭住址 -->
              <custom-form-item
                type="textarea"
                prop="address_formCode_FR101"
                v-model="formData.address_formCode_FR101"
                :fieldInfo="showFormFieldKeyInfo.address_formCode_FR101 || {}"
              />
              <!-- 爱好 -->
              <custom-form-item
                type="textarea"
                prop="interest_formCode_FR101"
                v-model="formData.interest_formCode_FR101"
                :fieldInfo="showFormFieldKeyInfo.interest_formCode_FR101 || {}"
              />
              <!-- 禁忌话题 -->
              <custom-form-item
                type="textarea"
                prop="sensitive_topic_formCode_FR101"
                v-model="formData.sensitive_topic_formCode_FR101"
                :fieldInfo="showFormFieldKeyInfo.sensitive_topic_formCode_FR101 || {}"
              />
            </div>
          </el-form>
        </div>

        <!-- 医生期望 -->
        <div v-show="activeTab === 'doctorWish'" class="tab-section">
          <el-form
            ref="doctorWishInfoForm"
            :model="formData"
            label-width="120px"
          >
            <div class="form-grid">
              <!-- 挂号费 -->
              <custom-form-item
                type="input"
                prop="register_price_formCode_FR102"
                v-model="formData.register_price_formCode_FR102"
                :fieldInfo="showFormFieldKeyInfo.register_price_formCode_FR102 || {}"
              />
              <!-- 挂号费提成 -->
              <custom-form-item
                type="input"
                prop="register_commission_formCode_FR102"
                v-model="formData.register_commission_formCode_FR102"
                :fieldInfo="showFormFieldKeyInfo.register_commission_formCode_FR102 || {}"
              />
              <!-- 药费提成 -->
              <custom-form-item
                type="input"
                prop="drug_commission_formCode_FR102"
                v-model="formData.drug_commission_formCode_FR102"
                :fieldInfo="showFormFieldKeyInfo.drug_commission_formCode_FR102 || {}"
              />
              <!-- 外治提成 -->
              <custom-form-item
                type="input"
                prop="physio_commission_formCode_FR102"
                v-model="formData.physio_commission_formCode_FR102"
                :fieldInfo="showFormFieldKeyInfo.physio_commission_formCode_FR102 || {}"
              />
              <!-- 坐诊医馆 -->
              <custom-form-item
                type="multiple-select"
                prop="practice_hospital_formCode_FR012"
                v-model="formData.practice_hospital_formCode_FR102"
                filterable
                :options="originOptionsInfo.practice_hospital_formCode_FR102 || []"
                :fieldInfo="showFormFieldKeyInfo.practice_hospital_formCode_FR102 || {}"
              />
              <!-- 坐诊时间 -->
              <custom-form-item
                type="multiple-select"
                prop="practice_time_formCode_FR012"
                v-model="formData.practice_time_formCode_FR102"
                filterable
                :options="originOptionsInfo.practice_time_formCode_FR102 || []"
                :fieldInfo="showFormFieldKeyInfo.practice_time_formCode_FR102 || {}"
              />
              <!-- 医生需求 -->
              <custom-form-item
                type="textarea"
                prop="expectation_formCode_FR102"
                v-model="formData.expectation_formCode_FR102"
                :fieldInfo="showFormFieldKeyInfo.expectation_formCode_FR102 || {}"
              />
              <!-- 储备区域 -->
              <custom-form-item
                type="multiple-select"
                prop="reserve_area_formCode_FR012"
                v-model="formData.reserve_area_formCode_FR102"
                filterable
                :options="originOptionsInfo.reserve_area_formCode_FR102 || []"
                :fieldInfo="showFormFieldKeyInfo.reserve_area_formCode_FR102 || {}"
              />
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const createFormCode = 'FR001'
const baseInfoFormCode = 'FR100'
const seePatientFormCode = 'FR103'
const assistantInfoFormCode = 'FR101'
const doctorWishFormCode = 'FR102'
const doctorFeedbackFormCode = 'FR013'

import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'
import CustomFormItem from '@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'

export default {
  name: 'AddClue',
  components: {
    CustomFormItem
  },
  data() {
    return {
      loading: false,
      instanceId: '', // 流程实例ID
      doctorId: '', // 医生ID
      stepCode: 'S020', // 步骤code
      stepId: '', // 步骤ID
      formCodeList: [],
      // 是否展开更多线索信息
      isExpanded: false,
      // 当前激活的标签页
      activeTab: 'basic',
      createFormCode,
      baseInfoFormCode,
      seePatientFormCode,
      assistantInfoFormCode,
      doctorWishFormCode,
      doctorFeedbackFormCode,
      // 基础表单数据
      formData: {
        doctorName: '',
        gender: '男',
        assignTo: 'follower',
        follower: '',
        ['doctor_id_formCode_' + createFormCode]: '', // 医生ID
        ['doctor_name_formCode_' + createFormCode]: '', // 医生姓名
        ['sex_formCode_' + createFormCode]: '', // 性别
        ['phone_formCode_' + createFormCode]: '', // 手机号
        ['wxid_formCode_' + createFormCode]: '', // 微信号
        // 基本信息
        ['age_formCode_' + baseInfoFormCode]: '', // 年龄
        ['birth_formCode_' + baseInfoFormCode]: '', // 生日
        placeOfOrigin: [], // 籍贯
        placeOfOriginTextList: [], // 籍贯文字
        placeOfOriginCodeList: [], // 籍贯编码
        ['school_formCode_' + baseInfoFormCode]: '', // 毕业院校
        ['aa_formCode_' + baseInfoFormCode]: '', // 职称
        ['ab_formCode_' + baseInfoFormCode]: '', // 荣誉称号
        ['inherit_formCode_' + baseInfoFormCode]: '', // 师承
        ['physio_type_formCode_' + baseInfoFormCode]: [], // 治疗方式
        ['showPhysioRate']: false, // 是否显示外治占比字段
        ['physio_rate_formCode_' + baseInfoFormCode]: '', // 外治占比
        ['income_month_amount_formCode_' + baseInfoFormCode]: [], // 月收入
        ['month_sale_amount_formCode_' + baseInfoFormCode]: '', // 月销售金额(自述)
        ['referrer_formCode_' + baseInfoFormCode]: '', // 介绍人
        // 辅助信息
        ['doctor_aid_id_formCode_' + assistantInfoFormCode]: '', // 辅助信息id
        ['is_marry_formCode_' + assistantInfoFormCode]: [], // 婚姻状况
        ['children_formCode_' + assistantInfoFormCode]: '', // 子女情况
        ['address_formCode_' + assistantInfoFormCode]: '', // 家庭住址
        ['interest_formCode_' + assistantInfoFormCode]: '', // 爱好
        ['sensitive_topic_formCode_' + assistantInfoFormCode]: '', // 禁忌话题
        // 期望信息
        ['doctor_expectation_id_formCode_' + doctorWishFormCode]: '', // 医生期望id
        ['register_price_formCode_' + doctorWishFormCode]: '', // 挂号费
        ['register_commission_formCode_' + doctorWishFormCode]: '', // 挂号费提成
        ['drug_commission_formCode_' + doctorWishFormCode]: '', // 药费提成
        ['physio_commission_formCode_' + doctorWishFormCode]: '', // 外治提成
        ['practice_hospital_formCode_' + doctorWishFormCode]: [], // 坐诊医馆
        ['practice_time_formCode_' + doctorWishFormCode]: [], // 坐诊时间
        ['expectation_formCode_' + doctorWishFormCode]: '', // 医生需求
        ['reserve_area_formCode_' + doctorWishFormCode]: [], // 储备区域
      },
      areaList: [],
      seePatientList: [],
      fieldList: [],
      showFormFieldKeyInfo: {}, // 表单字段信息
      originOptionsInfo: {},
      // 坐诊信息
      clinicInfo: {
        hospital: '',
        department: '',
        room: '',
        time: ''
      }
    }
  },
  async created() {
    try {
      this.loading = true
      const formCodeList = [createFormCode, baseInfoFormCode, assistantInfoFormCode, doctorWishFormCode, doctorFeedbackFormCode]
      await this.getFormFieldList(formCodeList)
      await this.getAreaList()
      this.formCodeList = formCodeList
      this.instanceId = await formFlow.createFlow()
      this.doctorId = await this.getDoctorId()
    } catch (error) {
      console.log('获取表单字段信息失败:', error)
    } finally {
      this.loading = false
    }
  },
  props: {
    roleType: {
      type: [String, Number],
      default: 0
    }
  },
  mounted() {
  },
  methods: {
    async getDoctorId() {
      try {
        const res = await request.get('/cluepool/doctor/createDoctorId', {}, '')
        if (res.code === 200) {
          this.doctorId = res.data || ''
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取医生id失败', error)
      }
    },
    // 获取省市区json
    async getAreaList() {
      try {
        const res = await request.get('/cluepool/area.json', {}, '')
        if (res.code === 200) {
          this.areaList = (res.data || []).map(item => ({
            ...item,
            list: (item.list || []).map(ite => ({
              name: ite.name,
              code: ite.code
            }))
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取省市区json失败', error)
      }
    },
    async getFormFieldList(formCodeList) {
      try {
        const {
          formData,
          showFormFieldKeyInfo,
          originOptionsInfo,
          fieldList,
          optionsInfo
        } = await formFlow.getFormFieldList(formCodeList)
        if (res.code === 200) {
          this.formData = {
            ...formData,
            placeOfOrigin: []
          }
          this.originOptionsInfo = originOptionsInfo
          this.fieldList = fieldList
          this.showFormFieldKeyInfo = showFormFieldKeyInfo
          console.log({formData, showFormFieldKeyInfo, originOptionsInfo, fieldList, optionsInfo})
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取表单字段信息失败:', error)
      }
    },
    // 表单校验
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('表单校验失败'))
          }
        })
      })
    },

    // 创建流程实例
    async createFlowHandle() {
      const { formData, showFormFieldKeyInfo } = this || {}
      const resultFormData = {
        formCode: createFormCode,
        fieldData: []
      }
      for (const key in showFormFieldKeyInfo) {
        let value = []
        if (key === ('doctor_id_formCode_' + createFormCode)) {
          value = utils.isEmpty(this.doctorId) ? [] : [this.doctorId]
        } else {
          value = utils.isEmpty(formData[key]) ? [] : [formData[key]]
        }
        resultFormData.fieldData.push({
          formFieldCode: showFormFieldKeyInfo[key].fieldCode,
          value
        })
      }
      const params = {
        flowCode: 'F001', // 流程编号
        flowInstanceId: this.instanceId, // 流程实例ID
        followAction: this.stepCode, // 下一步步骤code
        formData: [resultFormData]
      }
      let reqSuccess = false
      try {
        const res = await request.post('/cluepool/pc/form/startFlow', params, '')
        if (res.code === 200) {
          this.stepId = (((res.data || {}).tasks || []).sort((a, b) => b.stepId - a.stepId)[0] || {}).stepId || ''
          reqSuccess = true
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('表单校验失败:', error)
      }
      return reqSuccess
    },

    async submitOrderHandle() {
      // const { formCodeList, fieldList, formData } = this
      // for (const formCode of formCodeList) {
      //   if (formCode === seePatientFormCode) {
      //     // 坐诊信息
      //     [seePatientList, deleteSeePatientList].flat().forEach(el => {
      //       resultFormData.push({
      //         formCode: seePatientFormCode,
      //         fieldData: fieldList.filter(item => item.formCode === seePatientFormCode).map(item => {
      //           let value = []
      //           // 行政区省市区相关字段
      //           if (['province', 'city', 'region', 'province_name', 'city_name', 'region_name'].includes(item.fieldName)) {
      //             const hospitalCityInfo = el['hospitalCity_formCode_' + seePatientFormCode][0]
      //             let valueList = [], labelList = []
      //             if (hospitalCityInfo) {
      //               valueList = hospitalCityInfo.questionItemValue.split('-')
      //               labelList = hospitalCityInfo.questionItemLabel.split('-')
      //             }
      //             switch (item.fieldName) {
      //               case 'province':
      //                 value = utils.isEmpty(valueList[0]) ? [] : [(valueList[0]).toString()]
      //                 break
      //               case 'city':
      //                 value = utils.isEmpty(valueList[1]) ? [] : [(valueList[1]).toString()]
      //                 break
      //               case 'region':
      //                 value = utils.isEmpty(valueList[2]) ? [] : [(valueList[2]).toString()]
      //                 break
      //               case 'province_name':
      //                 value = utils.isEmpty(labelList[0]) ? [] : [(labelList[0]).toString()]
      //                 break
      //               case 'city_name':
      //                 value = utils.isEmpty(labelList[1]) ? [] : [(labelList[1]).toString()]
      //                 break
      //               case 'region_name':
      //                 value = utils.isEmpty(labelList[2]) ? [] : [(labelList[2]).toString()]
      //                 break
      //             }
      //           } else if (['doctor_id'].includes(item.fieldName)) {
      //             value = utils.isEmpty(el[item.resultFieldName]) ? [doctorId] : [el[item.resultFieldName]]
      //           } else {
      //             // 其他字段
    //               // 上传的图片
    //               if (Array.isArray(el[item.resultFieldName])) {
    //                 value = el[item.resultFieldName].map(item => item.replace(serverConfig.uploadImgBaseUrl, ''))
    //               } else {
    //                 value = utils.isEmpty(el[item.resultFieldName]) ? [] : [el[item.resultFieldName]]
    //               }
      //           }
      //           return {
      //             formFieldCode: item.fieldCode,
      //             // fieldName: item.fieldName,
      //             // zhName: item.zhName,
      //             value
      //           }
      //         }),
      //         operate: el.changeType === 'delete' ? '4' : ''
      //       })
      //     })
      //   } else {
      //     resultFormData.push({
      //       formCode,
      //       fieldData: fieldList.filter(item => item.formCode === formCode).map(item => {
      //         let value = []
      //         if (['doctor_id'].includes(item.fieldName)) {
      //           // 处理doctor_id字段
      //           value = doctorId ? [doctorId] : []
      //         } else if (item.fieldName === 'expectation') {
      //           // 全局的医生需求
      //           value = utils.isEmpty(formData['expectation_formCode_' + doctorWishFormCode])
      //                   ? []
      //                   : [formData['expectation_formCode_' + doctorWishFormCode]
      //         } else {
      //           // 其他字段
      //           // 图片上传
      //           if (Array.isArray(formData[item.resultFieldName])) {
      //             value = formData[item.resultFieldName].map(item => item.replace(serverConfig.uploadImgBaseUrl, ''))
      //           } else {
      //             value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName]]
      //           }
      //         }
      //         return {
      //           formFieldCode: item.fieldCode,
      //           // fieldName: item.fieldName,
      //           // zhName: item.zhName,
      //           value
      //         }
      //       })
      //     })
      //   }
      // }
      // const params = {
      //   flowInstanceId: this.instanceId,
      //   followAction: this.stepCode,
      //   formData: resultFormData,
      //   stepCode: this.stepCode,
      //   stepId: this.stepId
      // }

      // try {
      //   const res = await formFlow.submitFormData(params)
      //   return res.code === 200
      // } catch (error) {
      //   console.log('保存医生信息失败', error)
      //   return false
      // }
    },

    // 表单提交处理
    async submitHandle() {
      try {
        await this.validateForm()
        let reqSuccess = await this.createFlowHandle()
        if (reqSuccess) reqSuccess = await this.submitOrderHandle()
        return reqSuccess
      } catch (error) {
        return false
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.baseForm.resetFields()
    }
  }
}
</script>

<style scoped lang="less">
.add-clue {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  overflow: auto;
}

// 基础信息表单
.base-form {
  padding: 16px 20px;

  /deep/ .el-form-item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-form-item__label {
      font-size: 13px;
      color: #1F2329;
      padding-right: 12px;
    }

    .el-form-item__content {
      .form-input {
        width: 320px;
      }

      .form-select {
        width: 320px;
      }
    }
  }
}

// 标签页切换按钮
.tab-toggle {
  padding: 12px 20px 20px 30px;
  border-bottom: 1px solid #E8E8E8;

  .toggle-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #1890FF;
    font-size: 14px;
    cursor: pointer;
    user-select: none;

    i {
      font-size: 12px;
    }
  }
}

// 展开的内容区域
.expand-content {
  padding: 0 20px 16px;

  // 标签页样式
  .clue-tabs {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;

    /deep/ .el-tabs__header {
      margin-left: 0;
      margin-bottom: 16px;
    }

    /deep/ .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #E8E8E8;
    }

    /deep/ .el-tabs__item {
      font-size: 14px;
      color: #667182;

      &.is-active {
        color: #1890FF;
        font-weight: 500;
      }
    }

    /deep/ .el-tabs__active-bar {
      background-color: #1890FF;
    }
  }
  
  // 标签页内容区域
  .tab-content-area {
    .tab-section {
      padding-top: 4px;
      margin-bottom: 24px;
  
      &:last-child {
        margin-bottom: 0;
      }
  
      .form-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}

// 全局 el-tabs 样式覆盖
/deep/ .el-tabs {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  
  .el-tabs__header {
    padding-left: 0;
  }
}
</style>
